"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowActionType = void 0;
var WorkflowActionType;
(function (WorkflowActionType) {
    WorkflowActionType[WorkflowActionType["Received"] = 1] = "Received";
    WorkflowActionType[WorkflowActionType["Forwarded"] = 2] = "Forwarded";
    WorkflowActionType[WorkflowActionType["ReviewResponse"] = 3] = "ReviewResponse";
    WorkflowActionType[WorkflowActionType["Closed"] = 4] = "Closed";
    WorkflowActionType[WorkflowActionType["OfficialResponse"] = 5] = "OfficialResponse";
    WorkflowActionType[WorkflowActionType["Pending"] = 6] = "Pending";
    WorkflowActionType[WorkflowActionType["ReceivedPending"] = 7] = "ReceivedPending";
    WorkflowActionType[WorkflowActionType["Reopened"] = 8] = "Reopened";
    WorkflowActionType[WorkflowActionType["Created"] = 9] = "Created";
    WorkflowActionType[WorkflowActionType["Sent"] = 10] = "Sent";
    WorkflowActionType[WorkflowActionType["ProposalRequested"] = 11] = "ProposalRequested";
    WorkflowActionType[WorkflowActionType["ProposalSubmitted"] = 12] = "ProposalSubmitted";
    WorkflowActionType[WorkflowActionType["SignatureRequested"] = 13] = "SignatureRequested";
    WorkflowActionType[WorkflowActionType["ProposalApprovedSubmitted"] = 14] = "ProposalApprovedSubmitted";
    WorkflowActionType[WorkflowActionType["ProposalRejectedSubmitted"] = 15] = "ProposalRejectedSubmitted";
    WorkflowActionType[WorkflowActionType["CancelSignatureRequested"] = 16] = "CancelSignatureRequested";
    WorkflowActionType[WorkflowActionType["SignedProposalSent"] = 17] = "SignedProposalSent";
    WorkflowActionType[WorkflowActionType["ProposalUpdateRequested"] = 18] = "ProposalUpdateRequested";
})(WorkflowActionType = exports.WorkflowActionType || (exports.WorkflowActionType = {}));
//# sourceMappingURL=WorkflowActionType.js.map